import classNames from 'classnames'

/**
 * Simple mismatch icon that inherits the current text color.
 */
export default function MismatchIcon({ className }) {

  return (
    <svg
      viewBox='0 0 24 24'
      width='16'
      height='16'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
      className={classNames('transition-all duration-200', className)}
    >
      <circle
        cx='12'
        cy='12'
        r='9'
        fill='none'
        stroke='currentColor'
        strokeWidth='1.5'
      />
      <path
        d='M12 7.5v6'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
      />
      <circle
        cx='12'
        cy='16.5'
        r='1'
        fill='currentColor'
      />
    </svg>
  )
}
